module.exports = __webpack_public_path__ + "static/media/ThumbnailStill04.ed7903ea.png";